import React, { useContext } from "react"; 
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"; 
import { AuthContext } from "./context/auth.context"; 
import { un_auth_routes, routes } from "./routes"; 
import MiniDrawer from "./navigator/SideNav/sidenav"; // SideNav component

export default function MainRoutes() { 
    const { authenticated } = useContext(AuthContext);

    if (!authenticated) {
        return (
            <BrowserRouter>
                <Routes>
                    {un_auth_routes.map((route) => (
                        <Route key={route.key} path={route.route} element={<route.component />} />
                    ))}
                    <Route path="*" element={<Navigate to="/authentication/sign-in" />} />
                </Routes>
            </BrowserRouter>
        );
    } else {
        return (
            <BrowserRouter>
                <MiniDrawer routes={routes}>
                    <Routes>
                        {routes.map((route) => (
                            <Route key={route.key} path={route.route} element={route.component ? <route.component /> : null}>
                                {/* Render sub-routes only if they exist */}
                                {route.subRoutes && route.subRoutes.map((subRoute) => (
                                    <Route
                                        key={subRoute.key}
                                        path={subRoute.route}
                                        element={<subRoute.component />}
                                    />
                                ))}
                            </Route>
                        ))}
                        <Route path="*" element={<Navigate to="/dashboard" />} />
                    </Routes>
                </MiniDrawer>
            </BrowserRouter>
        
        );
    }
}
